<template>
  <v-container fluid>
    <v-tabs v-model="tab">
      <v-tab>Баланс и выплаты</v-tab>
      <v-tab>Мои аптеки</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item><PartnerBalance /></v-tab-item>
      <v-tab-item><PartnerPharmacies /></v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import PartnerBalance from "@/components/partner/PartnerBalance.vue";
import PartnerPharmacies from "@/components/partner/PartnerPharmacies.vue";

export default {
  name: "PartnerCabinet",
  components: { PartnerBalance, PartnerPharmacies },
  data: () => ({ tab: 0 }),
};
</script>
